import * as Actions from '../actions/register.actions';
import * as Constants from '../actions/register.constants';
import { RegisterState } from '../types/register-state';

const defaultState: Partial<RegisterState> = {
  emailExisting: false,
  checkingEmail: false,
  checkingDomain: false,
  complete: false,
  organisationRegisteredId: null
};

export function reducer(state: Partial<RegisterState> = defaultState, action: Actions.All)
  : Partial<RegisterState> {

  switch (action.type) {
    case Constants.INITIALIZE:
    case Constants.DESTROY: {
      return { ...defaultState };
    }
    case Constants.REGISTER_USER:
    case Constants.CONFIRM_VERIFICATION_CODE:
    case Constants.GET_VERIFICATION_CODE:
    case Constants.REGISTER_ORGANISATION: {
      return { ...state, loading: true };
    }
    case Constants.CHECK_EXISTING_EMAIL: {
      return { ...state, checkingEmail: true };
    }
    case Constants.CHECK_EXISTING_EMAIL_DONE: {
      const { exists } = action as Actions.CheckExistingEmailDoneAction;
      return { ...state, checkingEmail: false, emailExisting: exists };
    }
    case Constants.SET_USER_DETAILS: {
      const { type, ...details } = action as Actions.SetUserDetailsAction;
      return { ...state, ...details };
    }
    case Constants.SET_ORGANISATION_DETAILS: {
      const { type, ...details } = action as Actions.SetOrganisationDetailsAction;
      return { ...state, ...details };
    }
    case Constants.SET_VERIFICATION_DETAILS: {
      const { type, ...details } = action as Actions.SetVerificationDetailsAction;
      return { ...state, ...details };
    }
    case Constants.SET_ERROR_MESSAGE: {
      const { message } = action as Actions.SetErrorMessageAction;
      return { ...state, loading: false, message };
    }
    case Constants.CHECK_EXISTING_DOMAIN: {
      return { ...state, checkingDomain: true };
    }
    case Constants.CHECK_EXISTING_DOMAIN_DONE: {
      const { exists } = action as Actions.CheckExistingDomainDoneAction;
      return { ...state, checkingDomain: false, domainExisting: exists };
    }
    case Constants.REGISTER_ORGANISATION_DONE: {
      const { organisationId } = action as Actions.OrganisationRegistrationDone;
      return { ...state, organisationRegisteredId: organisationId };
    }
    default:
      return state;
  }

}